module.exports = __webpack_public_path__ + "img/five.3f46f674.png";